angular.module("app").run(function () {
    var s = document.head.getElementsByTagName('script')[0];
    var newScript = document.createElement('script');
    newScript.setAttribute('src', 'https://www.googletagmanager.com/gtag/js?id=UA-29242337-52');
    newScript.setAttribute('async', '');
    s.parentNode.insertBefore(newScript, s);
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', 'UA-29242337-52');
});